import { useMemo } from "react";
import { addDays } from "date-fns";

import {
  formatMetricUnit,
  formatRecurringCharge,
  AgreementInfo,
} from "../../../api/services";

export const useAgreement = (agreement: AgreementInfo) => {
  const { tariff, toDttm, currency } = agreement;
  const { taxInclusive, standingCharge, unitRate } = tariff || {};

  return useMemo(() => {
    const r = (unitRate?.rates || []).map(({ name, value }, index) => {
      const caption = `Rate${name ? `: ${name}` : ""}`;
      const text = `${value} ${formatMetricUnit(unitRate?.metricUnit || "")}`;
      return {
        caption,
        text,
      };
    });
    const c =
      standingCharge && currency
        ? formatRecurringCharge({
            currency,
            value: standingCharge.value,
            chargeFrequency: standingCharge.chargeFrequency,
          })
        : null;

    return {
      rates: r,
      charge: c,
      endDttm: toDttm ? addDays(new Date(toDttm), -1).toISOString() : null,
      taxDescription: taxInclusive
        ? "All prices include sales tax"
        : "All prices exclude sales tax",
    };
  }, [currency, standingCharge, taxInclusive, toDttm, unitRate]);
};
